// src/components/Sidebar/sidebarData.ts
import * as React from "react";
import { FiHome, FiUser, FiSettings } from "react-icons/fi";
import ROUTES from "../../../router/constants";

export const sidebarData = [
  { path: `${ROUTES.vendorDashboard}`, label: "Dashboard" },
  { path: `${ROUTES.addListing}`, label: "Add Listing" },
  { path: `${ROUTES.manageListing}`, label: "Manage Listing" },
];
